import React from 'react';
import '../components/grammar-page.css';
import { FaBookOpen, FaLightbulb } from 'react-icons/fa';

const DescriptiveAdjectivesExplanation = () => {
  return (
    <div className="grammar-explanation">
      <h2><FaBookOpen /> Descriptive Adjectives</h2>
      <p>
        Descriptive adjectives give nuanced feedback and describe character traits in detail.
        They can be used <strong>attributively</strong> (before a noun: <em>a decisive leader</em>) or
        <strong>predicatively</strong> (after a linking verb: <em>She is approachable</em>).
      </p>

      <div className="grammar-explanation-grid">
        <div className="example-block">
          <h3><FaLightbulb /> Common suffixes</h3>
          <ul>
            <li><strong>-ive:</strong> a tendency or function (proactive, decisive, assertive)</li>
            <li><strong>-able / -ible:</strong> capability or worth (approachable, reliable, responsible)</li>
            <li><strong>-ous:</strong> full of a quality (conscientious, courageous)</li>
            <li><strong>-al:</strong> relating to (ethical, rational, analytical)</li>
          </ul>
        </div>

        <div className="example-block">
          <h3><FaLightbulb /> Compound adjectives and opposites</h3>
          <ul>
            <li><strong>Compound adjectives:</strong> easy-going, narrow-minded, quick-witted</li>
            <li><strong>Prefixes for opposites:</strong> un-, in-, im-, dis- (reliable → unreliable, considerate → inconsiderate)</li>
            <li><strong>Gradability:</strong> modifiers like <em>exceptionally</em>, <em>somewhat</em>, <em>highly</em> add precision</li>
          </ul>
        </div>
      </div>

      <h3><FaLightbulb /> Trait vocabulary</h3>
      <div className="grammar-flex-table">
        {[
          ['Quality', 'Positive', 'Negative / Opposite'],
          ['Decision making', 'Decisive', 'Indecisive'],
          ['Communication', 'Articulate', 'Incoherent'],
          ['Empathy', 'Compassionate', 'Callous'],
          ['Work ethic', 'Conscientious', 'Negligent'],
          ['Social behavior', 'Friendly / Outgoing', 'Quiet / Shy'],
          ['Intellect', 'Smart / Clever', 'Naive / Foolish'],
        ].map(([quality, positive, negative], index) => (
          <div key={index} className={`grammar-flex-row${index === 0 ? ' header' : ''}`}>
            <div className="grammar-cell">{quality}</div>
            <div className="grammar-cell">{positive}</div>
            <div className="grammar-cell">{negative}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DescriptiveAdjectivesExplanation;
